import React, { useEffect } from "react"
import { Box, Skeleton, styled } from "@mui/material"

import { colors } from "theme"
import { useAppDispatch, useAppSelector } from "redux/hooks"
import { fetchPurchasedProducts } from "redux/features/purchased_product/purchasedProductThunk"
import {
  selectFetchCollectionStatus,
  selectPurchasedProducts,
} from "redux/features/purchased_product/purchasedProductSlice"
import LoadableCollection from "components/ui/LoadableCollection"
import { PurchasedProductListType } from "types"

export function withPurchasedProducts<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithPurchasedProducts = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const purchasedProducts = useAppSelector((state) =>
      selectPurchasedProducts(state),
    ) as PurchasedProductListType
    const fetchStatus = useAppSelector((state) =>
      selectFetchCollectionStatus(state),
    )

    const handleFetchPurchasedProducts = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchPurchasedProducts())
      }
    }

    useEffect(() => handleFetchPurchasedProducts(), [])

    const renderSkeleton = () => {
      return (
        <Container>
          <Card sx={{ height: 500 }} animation="pulse" variant="rectangular" />
        </Container>
      )
    }

    return (
      <LoadableCollection
        fetchStatus={fetchStatus}
        renderLoading={renderSkeleton}
      >
        {() => <WrappedComponent {...props} items={purchasedProducts} />}
      </LoadableCollection>
    )
  }

  return WithPurchasedProducts
}

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 42px 0 0 0;
`

const Card = styled(Skeleton)`
  background-color: ${colors.cultured};
  box-shadow: 12px 14px 23px -2px rgb(0 0 0 / 3%);
  border-radius: 26px;
  margin-bottom: 16px;
  padding: 58px;
  width: 100%;
`
